import * as yup from 'yup'

import { trimmedInputValues, capitalizeWordsInValue} from '../utils'

const ShippingAddrValidationSchema = yup.object().shape({
    address: yup.string()
         .transform((value) => trimmedInputValues(value))
         .required('Please enter address'),
    // address1: yup.string()
    //     .transform((value) => trimmedInputValues(value))
    //     .required('Please enter address1'),
    // address2: yup.string()
    //     .transform((value) => trimmedInputValues(value))
    //     .required('Please enter address2'),
    stateId: yup.string().required('Please select state'),
    countryId: yup.string().required('Please select country'),
    city: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter city')
        .transform((value) => trimmedInputValues(value)),
    pinCode: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter pincode')
        .test('pincodeLength', function(value) {
            const pmCompanyConfig = this.options.context
            
            const pinCodeLength = pmCompanyConfig.pinCodeLength
            const pinCodeErrorMessage = `Must be exactly ${pinCodeLength} characters`;
            
            if (value && value.length !== pinCodeLength) {
              return this.createError({ message: pinCodeErrorMessage })
            }
            return true
        }),
})

const shippingAddressInitialState = {
    address: '',
    // address1: '',
    // address2: '',
    stateId: null,
    countryId: null,
    city: '',
    pinCode: '',
}

export { ShippingAddrValidationSchema, shippingAddressInitialState };